module.exports = __webpack_public_path__ + "media/images/storage-info-img1-43aebd95fc9f3c4cd9aa8e9aca6d2425.png";